import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={200}
    height={200}
    className="icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M512.09 1024a93.425 93.425 0 1 1 93.425-93.425A93.604 93.604 0 0 1 512.09 1024zm0-139.51a46.085 46.085 0 1 0 46.085 46.085 46.085 46.085 0 0 0-46.085-46.085zM842.036 395.13h67.962q61.327 0 61.327 61.326v173.222q0 61.327-61.327 61.327h-67.962q-61.327 0-61.327-61.327V456.456q0-61.326 61.327-61.326Z"
    />
    <path
      fill="currentColor"
      d="M876.107 714.855A119.247 119.247 0 0 1 756.86 595.787v-105.26a119.068 119.068 0 0 1 238.135 0v105.26a119.247 119.247 0 0 1-118.888 119.068zm0-296.055a71.727 71.727 0 0 0-71.728 71.727v105.26a71.727 71.727 0 0 0 143.455 0v-105.26a71.727 71.727 0 0 0-71.727-71.727zM113.82300000000001 395.13h67.962q61.327 0 61.327 61.326v173.222q0 61.327-61.327 61.327h-67.962q-61.327 0-61.327-61.327V456.456q0-61.326 61.327-61.326Z"
    />
    <path
      fill="currentColor"
      d="M147.176 714.855a119.247 119.247 0 0 1-118.35-119.068v-105.26a119.068 119.068 0 0 1 238.135 0v105.26a119.247 119.247 0 0 1-119.785 119.068zm0-296.055a71.727 71.727 0 0 0-71.727 71.727v105.26a71.727 71.727 0 0 0 143.455 0v-105.26a71.727 71.727 0 0 0-71.728-71.727zm434.31 528.81a23.67 23.67 0 0 1-3.945-46.981 340.705 340.705 0 0 0 255.17-219.845 23.67 23.67 0 1 1 44.65 15.96A389.121 389.121 0 0 1 585.97 947.79z"
    />
    <path
      fill="currentColor"
      d="M876.107 419.875a23.67 23.67 0 0 1-23.67-23.67 340.705 340.705 0 1 0-681.411 0 23.67 23.67 0 0 1-47.34 0 387.866 387.866 0 1 1 775.553 0 23.67 23.67 0 0 1-23.132 23.67z"
    />
  </svg>
);
export default SvgComponent;
